function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/**
 * Game / module crypto transfer confirmation & orchestration UI.
 *
 * Wiring (post split from Send):
 *   - saito-crypto-send-render-request   → handled only by Send (validates + forwards)
 *   - saito-crypto-send-confirm-open-request → show overlay + run `mycallback` once
 *   - saito-crypto-send-confirm          → apply success / failure result
 *
 * Presentation: `mods/crypto/web/css/crypto-overlays.css` (`.crypto-send-confirm-overlay`).
 */

var ConfirmTemplate = require('./confirm.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var SaitoUser = require('./../../saito-user/saito-user');
var Confirm = /*#__PURE__*/function () {
  function Confirm(app, mod) {
    var _this = this;
    _classCallCheck(this, Confirm);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false);
    this.counter_party = new SaitoUser(this.app, this.mod, '#crypto-send-confirm-root .counterparty-details');
    this.el = null;
    this.timeout = null;
    this.countdownTimer = null;
    this.app.connection.on('saito-crypto-send-confirm-open-request', function (details) {
      console.log('saito-crypto-send-confirm-open-requests', details);
      _this.render(details);
    });
    this.app.connection.on('saito-crypto-send-confirm', function (rtnValue, callback_on_close) {
      _this.applyResult(rtnValue);
      _this.callback = callback_on_close;
    });
  }
  return _createClass(Confirm, [{
    key: "clearTimers",
    value: function clearTimers() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
      if (this.countdownTimer) {
        clearTimeout(this.countdownTimer);
        this.countdownTimer = null;
      }
    }

    /**
     * @returns {null | {
     *   root: HTMLElement,
     *   title: HTMLElement | null,
     *   detailMessage: HTMLElement | null,
     *   countdown: HTMLElement | null,
     * }}
     */
  }, {
    key: "bindElements",
    value: function bindElements() {
      var root = document.getElementById('crypto-send-confirm-root');
      if (root) {
        return {
          root: root,
          title: root.querySelector('#crypto_send_confirm_title'),
          detailMessage: root.querySelector('#crypto_send_confirm_detail'),
          countdown: root.querySelector('#crypto_send_confirm_countdown')
        };
      }
      return null;
    }

    /**
     * @param details {{ ticker?: string, amount?: string, publicKey?: string, address?: string, trusted?: boolean, mycallback?: function }}
     * @returns {{ ok: true } | { ok: false, message: string }}
     */
  }, {
    key: "validateOpen",
    value: function validateOpen(details) {
      if (!(details !== null && details !== void 0 && details.ticker) || !(details !== null && details !== void 0 && details.amount)) {
        return {
          ok: false,
          message: 'Missing currency or amount for this transfer.'
        };
      }
      if (!(details !== null && details !== void 0 && details.publicKey) || !(details !== null && details !== void 0 && details.address)) {
        return {
          ok: false,
          message: 'Missing recipient or destination address.'
        };
      }
      return {
        ok: true
      };
    }

    /**
     * @param details {{ ticker: string, amount: string, publicKey: string, address: string, trusted?: boolean, mycallback?: function }}
     */
  }, {
    key: "render",
    value: function render(details) {
      var _this2 = this,
        _this$el;
      var check = this.validateOpen(details);
      if (!check.ok) {
        console.error('Crypto send confirm overlay:', check.message);
        return;
      }
      this.clearTimers();
      this.overlay.show(ConfirmTemplate(details), function () {
        // We can pass a callback to be run after the overlay is closed...
        if (_this2.callback) {
          _this2.callback();
        }
        _this2.el = null;
        _this2.callback = null;
        _this2.clearTimers();
      });
      this.overlay.blockClose('#crypto_send_confirm_close');
      this.el = this.bindElements();
      if (!((_this$el = this.el) !== null && _this$el !== void 0 && _this$el.root)) {
        console.error('bindElement failure...');
        this.overlay.close();
        return;
      }
      this.counter_party.publicKey = details.publicKey;
      this.counter_party.render();
      // Compact identity only — omit full address from this overlay.

      if (details !== null && details !== void 0 && details.mycallback) {
        details.mycallback();
      }
      this.attachEvents();
      if (details !== null && details !== void 0 && details.trusted) {
        this.timeout = setTimeout(function () {
          _this2.overlay.close();
          _this2.timeout = null;
        }, 3000);
        this.scheduleCountdownTick();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var cls_btn = document.querySelector('#crypto-send-confirm-root #crypto_send_confirm_close');
      if (cls_btn) {
        cls_btn.onclick = function () {
          _this3.overlay.close();
        };
      }
    }
  }, {
    key: "scheduleCountdownTick",
    value: function scheduleCountdownTick() {
      var _this4 = this;
      this.countdownTimer = setTimeout(function () {
        var _this4$el;
        _this4.countdownTimer = null;
        var span = (_this4$el = _this4.el) === null || _this4$el === void 0 ? void 0 : _this4$el.countdown;
        if (!span || !document.body.contains(span)) {
          return;
        }
        var value = parseInt(span.textContent, 10);
        if (Number.isNaN(value)) {
          value = 0;
        }
        value = Math.max(value - 1, 0);
        span.textContent = String(value);
        if (value > 0) {
          _this4.scheduleCountdownTick();
        }
      }, 900);
    }

    /**
     * @param results {{ hash?: string, err?: unknown }}
     */
  }, {
    key: "applyResult",
    value: function applyResult(results) {
      var _this5 = this;
      var el = this.bindElements();
      if (!el) {
        return;
      }
      console.log(results);
      var success = Boolean((results === null || results === void 0 ? void 0 : results.hash) && !(results !== null && results !== void 0 && results.err));
      if (el.title) {
        el.title.textContent = success ? 'Payment Sent' : 'Payment Failed';
      }
      el.root.dataset.confirmState = success ? 'success' : 'failed';
      if (success) {
        el.root.classList.remove('crypto-send-confirm-overlay--has-detail');
        if (el.detailMessage) {
          el.detailMessage.textContent = '';
        }
      }
      if (!success && el.detailMessage) {
        var err = results === null || results === void 0 ? void 0 : results.err;
        var msg = typeof err === 'string' ? err : err && _typeof(err) === 'object' && 'message' in err && typeof err.message === 'string' ? err.message : '';
        el.detailMessage.textContent = msg || 'This transfer could not be confirmed.';
        el.root.classList.add('crypto-send-confirm-overlay--has-detail');
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this5.overlay.close();
          _this5.timeout = null;
        }, 3000);
        if (el.countdown) {
          el.countdown.textContent = '3';
        }
      }
    }
  }]);
}();
module.exports = Confirm;